import './index.css';
import { useLink, useRouteLocation } from 'react-router-stack';
import { useState, SyntheticEvent, useEffect } from 'react';
import { View, Text, RouteWrapper, ScreenBackground, Header } from '../../../component';
import GrandLeagueLeaderBoardTab from '../../component/grand_league_leaderboard_tab';
import GrandLeagueWinnings from '../../component/grand_league_winnings';
import GrandLeagueLeaderBoardList from '../../component/grand_league_leaderboard_list';
import SwipeableViews from 'react-swipeable-views';
import Constants from '../../../constants';
import useTheme from '../../../utilities/hooks/theme';
const GrandLeagueLeaderboard = () => {
  const { FantasyTheme: theme } = useTheme();
  const navigate = useLink();
  const location = useRouteLocation() as any;
  const [activeLeaderBoardTab, setActiveLeaderBoardTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (location.state) {
      const { type = '' } = location.state as any;
      setActiveLeaderBoardTab(type === 'GL' ? 0 : 1);
    }
  }, []);

  const [routes] = useState([
    { key: 'Winnings_Breakup', title: 'Winnings Breakup' },
    { key: 'Leaderboard', title: 'Leaderboard' }
  ]);

  const onSetGrandLeaderboard = () => {
    setActiveLeaderBoardTab(0);
  };

  const onSetSmallLeaderboard = () => {
    setActiveLeaderBoardTab(1);
  };

  const onChangeIndex = (index = 0) => {
    setActiveTab(index);
  };
  const onChangeTab = (_event: SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header onClickBack={onPressBack} title="T-20 League Leaderboard" />
        <View className="grand-league-leaderboard-tab-container ">
          <Text
            style={{
              color:
                activeLeaderBoardTab === 0
                  ? theme.GLLeaderBoardTabActiveTitle
                  : theme.GLLeaderBoardTabInActiveTitle,
              fontFamily: activeLeaderBoardTab === 0 ? 'ProximaNova-Bold' : 'ProximaNova-Regular',
              borderBottomColor: activeLeaderBoardTab === 0 ? '#788fa3' : 'transparent'
            }}
            onPress={onSetGrandLeaderboard}
            className={'grand-league-leaderboard-tab'}>
            {'Grand League'}
          </Text>
          <Text
            onPress={onSetSmallLeaderboard}
            style={{
              color:
                activeLeaderBoardTab === 0
                  ? theme.GLLeaderBoardTabActiveTitle
                  : theme.GLLeaderBoardTabInActiveTitle,
              fontFamily: activeLeaderBoardTab === 1 ? 'ProximaNova-Bold' : 'ProximaNova-Regular',
              borderBottomColor: activeLeaderBoardTab === 1 ? '#788fa3' : 'transparent'
            }}
            className={'grand-league-leaderboard-tab'}>
            {'Small League'}
          </Text>
        </View>
        <View className={'grand-league-leaderboard-tab-view-wrapper '}>
          <GrandLeagueLeaderBoardTab
            activeTab={activeTab}
            onChangeTab={onChangeTab}
            routes={routes}
          />
          <div className="flat-list-outer-grow">
            <SwipeableViews
              index={activeTab}
              onChangeIndex={onChangeIndex}
              className={'grand-league-leaderboard-swipeable-view'}>
              <GrandLeagueWinnings
                list={
                  activeLeaderBoardTab == 0
                    ? Constants.GrandLeagueLeaderBoardList
                    : Constants.SmallLeagueLeaderBoardList
                }
              />
              <GrandLeagueLeaderBoardList activeLeague={activeLeaderBoardTab} />
            </SwipeableViews>
          </div>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default GrandLeagueLeaderboard;
